import React from 'react';
import { Link } from 'react-router-dom';
import { FaBuilding, FaUsers } from 'react-icons/fa';

const RegisterType = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Create an Account</h2>
        <p>Select your account type:</p>
        
        <div className="register-options">
          <Link to="/register/company" className="register-option">
            <div className="option-icon">
              <FaBuilding size={40} />
            </div>
            <h3>Company</h3>
            <p>Register as a business or industrial company</p>
          </Link>
          
          <Link to="/register/association" className="register-option">
            <div className="option-icon">
              <FaUsers size={40} />
            </div>
            <h3>Association</h3>
            <p>Register as an industry association or group</p>
          </Link>
        </div>
        
        <p className="auth-footer">
          Already have an account? <Link to="/login">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterType;
